export const getLockedFilterParams = (
  filterObject: Record<string, any> | undefined
): string[] => {
  if (!filterObject) {
    return [];
  }

  const params = new Set<string>();
  const collect = (node: Record<string, any>) => {
    Object.keys(node).forEach((key) => {
      if (Array.isArray(node[key])) {
        // or/and group — the key is a group operator, params live in branches
        node[key].forEach((branch) => {
          if (branch && typeof branch === 'object') {
            collect(branch);
          }
        });
        return;
      }
      params.add(key);
    });
  };
  collect(filterObject);

  return Array.from(params);
};
